import styled from 'styled-components'

export const CountryFlagWrapper = styled.div`
  flex: 1;
  margin: 4px 0;
`
